import { isAbsent } from '@yp/common/identity.ts';
import { metaStore } from '../../config/store.ts';

export function checkUpdate(version: string) {
  const meta = metaStore();
  const prior = meta.get('version');
  if (isAbsent(prior)) {
    meta.set('version', version);
  } else if (prior !== version) {
    console.warn('Version update required.', { current: version, prior });
    meta.set('version', version);
    return true;
  }
  console.info('Version is up to date.', { version });
  return false;
}
